import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {
    BrowserRouter as Router,
    Route
} from 'react-router-dom';
import { Provider } from 'react-redux';
import { connect } from 'react-redux';
import { Layout } from 'antd';

import { init } from './modules/app';
import App from './components/App';
import Spinner from './components/Spinner';
import registerServiceWorker from './registerServiceWorker';
import configureStore from './configureStore';

const store = configureStore();
const { Header, Content } = Layout;

class RootClass extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoaded: false
    };
  }

  async componentDidMount() {
    await this.props.dispatch(init());

    this.setState({
      isLoaded: true
    });
  }

  render() {
    if (this.state.isLoaded === false) {
      return (
        <Layout>
          <Header style={{padding: '0 20px', backgroundColor: '#E0156A'}}>
            <h1 style={{color: '#fff'}}>UXID</h1>
          </Header>
          
          <Content style={{ padding: '20px' }}>
              <div style={{ background: '#fff', padding: '20px' }}>
                <Spinner />
              </div>
          </Content>
        </Layout>
      );
    }

    return (
      <Router>
        <Route path={'/'} component={App} />
      </Router>
    );
  }
}

const Root = connect()(RootClass);

ReactDOM.render(
  <Provider store={store}>
    <Root />
  </Provider>, 
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js